module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    ref: "textbox",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.label,
      "value": _vm.displayDate,
      "hide-details": _vm.hideDetails,
      "persistent-hint": !_vm.hideDetails,
      "hint": _vm.dueString(_vm.value)
    },
    on: {
      "change": _vm.changed,
      "focus": _vm.focused,
      "blur": _vm.blurred,
      "dblclick": function($event) {
        $event.stopPropagation();
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ffe7e24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/DateBox.vue
// module id = 2498
// module chunks = 1